import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import { t, isEn } from "../i18n";

function Step({ n, children }) {
  return (
    <li className="flex gap-3">
      <span className="flex-shrink-0 h-6 w-6 rounded-sm bg-primary/15 text-primary text-xs font-bold flex items-center justify-center font-mono">
        {n}
      </span>
      <span className="text-sm text-muted-foreground leading-relaxed pt-0.5">{children}</span>
    </li>
  );
}

export function SetupModal({ open, onOpenChange, url }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="setup-modal">
        <DialogHeader>
          <DialogTitle className="font-display">{t("Como usar no OBS / vMix")}</DialogTitle>
        </DialogHeader>
        <div className="font-mono text-xs bg-black/40 border border-border rounded-sm p-3 break-all mb-2">
          {url}
        </div>
        <Tabs defaultValue="obs">
          <TabsList className="grid grid-cols-2 w-full">
            <TabsTrigger value="obs" data-testid="setup-tab-obs">OBS Studio</TabsTrigger>
            <TabsTrigger value="vmix" data-testid="setup-tab-vmix">vMix</TabsTrigger>
          </TabsList>
          <TabsContent value="obs">
            {isEn() ? (
            <ol className="space-y-3 mt-4">
              <Step n="1">Sources → <b>+</b> → <b>Browser</b> (Browser Source).</Step>
              <Step n="2">Paste the URL above into the <b>URL</b> field.</Step>
              <Step n="3">Set <b>Width 1920</b> and <b>Height 1080</b>.</Step>
              <Step n="4">Check <b>"Shutdown source when not visible"</b> and <b>"Refresh browser when scene becomes active"</b>.</Step>
              <Step n="5">The background is already transparent — no extra setup needed.</Step>
            </ol>
            ) : (
            <ol className="space-y-3 mt-4">
              <Step n="1">Fontes → <b>+</b> → <b>Navegador</b> (Browser Source).</Step>
              <Step n="2">Cole a URL acima no campo <b>URL</b>.</Step>
              <Step n="3">Defina <b>Largura 1920</b> e <b>Altura 1080</b>.</Step>
              <Step n="4">Marque <b>"Desligar fonte quando não visível"</b> e <b>"Atualizar navegador quando a cena ficar ativa"</b>.</Step>
              <Step n="5">O fundo já é transparente — nenhuma configuração extra é necessária.</Step>
            </ol>
            )}
          </TabsContent>
          <TabsContent value="vmix">
            {isEn() ? (
            <ol className="space-y-3 mt-4">
              <Step n="1">Add Input → <b>Web Browser</b>.</Step>
              <Step n="2">Paste the URL above and set <b>1920×1080</b>.</Step>
              <Step n="3">Make sure the input runs with an <b>alpha channel</b> (transparency).</Step>
              <Step n="4">Disable the built-in browser cache, if available, so media changes are reflected.</Step>
            </ol>
            ) : (
            <ol className="space-y-3 mt-4">
              <Step n="1">Add Input → <b>Web Browser</b>.</Step>
              <Step n="2">Cole a URL acima e defina <b>1920×1080</b>.</Step>
              <Step n="3">Confirme que o input opera com <b>canal alpha</b> (transparência).</Step>
              <Step n="4">Desative o cache do navegador embutido, se disponível, para refletir trocas de mídia.</Step>
            </ol>
            )}
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
